import React, { Component } from 'react';
import Header from '../common/Header';
import Sidebar from '../common/Sidebar';
import TextInput from '../common/TextInput';
import MobileNotification from '../common/MobileNotification';
import { FormGroup, FormControl, Modal } from 'react-bootstrap';
import Upload from '../common/Upload';
import { map, each, indexOf, remove, cloneDeep, concat, slice, isEmpty, findIndex, size } from 'lodash';
import Button from '../common/Button';
import WorkingTime from './WorkingTime';
import ActivationStepDetails from '../common/ActivationStepDetails';
import { validateFormSubmit } from '../../helpers';
import { validationMessage, imageBasePath, appBasePath } from '../../constants/staticData';
import { has, trimStart } from 'lodash';
import SelectAddressModal from './SelectAddressModal';
var uniqid = require('uniqid');
import LightBox from '../common/LightBox';

class ProfileCreation extends Component {
  constructor(props, context) {
    super(props, context);
    this.formData = {};
    this.toggleNotification = this.toggleNotification.bind(this);
    this.changeWorkingHours = this.changeWorkingHours.bind(this);
    this.setAsCover = this.setAsCover.bind(this);
    this.findPos= this.findPos.bind(this);
    this.props.actions.clearGarageProfileBatchId();
    this.state = {
      errorUpdated: false,
      testCompanyImage: {},
      showComapanyLogoModal: false,
      newImagesArray: [],
      showModal: false,
      imageStartIndex: 0,
      isEditable: false,
      selectedImages: [],
      imageMaxLimitError: false,
      setCenter: false,
      selectedLocation: { lat: 25.206840, lng: 55.273793 },
      fromTime: '12:00 AM',
      toTime: '11:59 PM',
      value: '',
      textUpdated: false,
      cash: false,
      card: false,
      imagesLeft: false,
      submissionError: false,
      notificationVisible: false,
      showSidebar: false,
      uploadImgSize: 0,
      uploadImageErrText: false,
      workingHours: [],
      companyLogo: {},
      daySelected: {
        sunday: false,
        monday: false,
        tuesday: false,
        wednesday: false,
        thrusday: false,
        friday: false,
        saturday: false
      },
      facilitiesMasterList: [],
      selectedFacilities: [],
      garageProfileDetails: null,
      deletedImages: [],
      showLocationModal: false,
      isButtonLoading: false,
      uploadedImageLength: 0,
      totalImageLength: 0
    };
    const authData = localStorage.businessAuthData ? JSON.parse(localStorage.businessAuthData) : '';
    this.formData = {
      companyprofilename: authData && authData.companyName ? authData.companyName : '',
      promotiontext: '',
      displaytext: '',
      about: '',
      address: '',
      phone: authData && authData.phone ? authData.phone.substring(4) : '',
      email: authData && authData.email ? authData.email : '',
      website: '',
      company_logo: [],
      cover_image: [],
    };
    this.errors = {
      companyprofilename: false,
      address: false,
      about: false,
      phone: false,
      email: false,
      company_logo: false,
      working_hours: false,
      working_hours_limit: false,
      imageMaxLimitError: false,
      cover_image: false,
    };
    this.uploadImageError = this.uploadImageError.bind(this);
  }

  toggleNotification(isVisible) {
    this.setState({ notificationVisible: isVisible });
  }
  hclickCallBack() {
    this.setState({ showSidebar: !this.state.showSidebar });
  }

  isFacilitySelected(facilityId) {
    if (this.state.selectedFacilities) {
      let index = indexOf(this.state.selectedFacilities, facilityId);
      if (index != -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  facilityChanged(value, facility) {
    let selectedFacilities = [...this.state.selectedFacilities];
    if (value) {
      if (indexOf(selectedFacilities, facility.id) == -1) {
        selectedFacilities.push(facility.id);
      }
    } else {
      remove(selectedFacilities, function(f) {
        return f == facility.id;
      });
    }
    this.setState({ selectedFacilities: selectedFacilities });
  }

  componentWillMount() {
    const authData = localStorage.businessAuthData ? JSON.parse(localStorage.businessAuthData) : '';
    let batchID = this.props.vendorProfileReducer &&
      this.props.vendorProfileReducer.garageProfileDetails &&
      this.props.vendorProfileReducer.garageProfileDetails.batchId;
    this.props.actions.hideToastMessage();
    this.props.actions.createGarageProfileBatchId(authData.isGarageProfileCompleted && batchID ? batchID : false);
    if (authData.isBusinessRegistered) {
      if (authData.isGarageProfileCompleted) {
        this.props.actions.getGarageProfile(authData.garageId);
      }
      this.props.actions.getFacilities();
    } else {
      this.props.router.push(`${appBasePath}/business-detail`);
    }

    this.formData = {
      companyprofilename: authData && authData.companyName ? authData.companyName : '',
      promotiontext: '',
      displaytext: '',
      about: '',
      phone: authData && authData.phone ? authData.phone.substring(4): '',
      email: authData && authData.email ? authData.email : '',
      website: '',
      company_logo: []
    };
  }
  componentDidMount() {
    if (navigator.geolocation) {
      const that = this;
      navigator.geolocation.getCurrentPosition(function (position) {
        that.setState({ 'selectedLocation': { 'lat': position.coords.latitude, 'lng': position.coords.longitude } });
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.vendorProfileReducer.hideButtonLoader && this.state.isButtonLoading) {
      this.setState({ isButtonLoading: false });
    }
    if (
      nextProps.vendorProfileReducer &&
      nextProps.vendorProfileReducer.garageProfileDetails &&
      !isEmpty(nextProps.vendorProfileReducer.garageProfileDetails)
    ) {
      let garageProfileDetails = nextProps.vendorProfileReducer.garageProfileDetails;
      this.formData = {
        companyprofilename: garageProfileDetails.companyprofilename,
        promotiontext: garageProfileDetails.displaytext,
        about: garageProfileDetails.about,
        address: garageProfileDetails.address,
        latitude: Number(garageProfileDetails.latitude),
        longitude: Number(garageProfileDetails.longitude),
        phone: garageProfileDetails.phone ? garageProfileDetails.phone.substring(4) : this.formData.phone,
        email: garageProfileDetails.email || this.formData.email,
        website: garageProfileDetails.website,
        company_logo: garageProfileDetails.logo
          ? [
              {
                thumbnail: garageProfileDetails.logo,
                original: garageProfileDetails.logo
              }
            ]
          : []
      };
      let facilityIds = [];
      map(nextProps.vendorProfileReducer.garageProfileDetails.garage_facilities, facility => {
        facilityIds.push(facility.lookupmasterId);
      });
      this.setState({
        isEditable: true,
        value: garageProfileDetails.phone,
        companyLogo: nextProps.vendorProfileReducer.garageProfileDetails.logo
          ? [{ original: garageProfileDetails.logo, thumbnail: garageProfileDetails.logo }]
          : [],
        workingHours: nextProps.vendorProfileReducer.garageProfileDetails.garage_timings
          ? nextProps.vendorProfileReducer.garageProfileDetails.garage_timings
          : [],
        garageProfileDetails: nextProps.vendorProfileReducer.garageProfileDetails,
        cash: nextProps.vendorProfileReducer.garageProfileDetails.cashpayment
          ? nextProps.vendorProfileReducer.garageProfileDetails.cashpayment
          : false,
        card: nextProps.vendorProfileReducer.garageProfileDetails.ccpayment
          ? nextProps.vendorProfileReducer.garageProfileDetails.ccpayment
          : false,
        selectedFacilities: facilityIds,
        imagesLeft: nextProps.vendorProfileReducer.garageProfileDetails.images
          ? nextProps.vendorProfileReducer.garageProfileDetails.images.length > 3 ? true : false
          : false,
        address: garageProfileDetails.address,
        selectedLocation: {
          lat: garageProfileDetails.latitude ? Number(garageProfileDetails.latitude) : this.state.selectedLocation.lat,
          lng: garageProfileDetails.longitude
            ? Number(garageProfileDetails.longitude)
            : this.state.selectedLocation.lng,
          address: garageProfileDetails.address || this.state.selectedLocation.address
        }
      });
    }
    if (nextProps.vendorProfileReducer && nextProps.vendorProfileReducer.facilitiesMasterList) {
      this.setState({ facilitiesMasterList: nextProps.vendorProfileReducer.facilitiesMasterList });
    }
    if (nextProps.vendorProfileReducer.newGarageProfileData) {
      let imageArray = [...this.state.selectedImages];
      map(nextProps.vendorProfileReducer.newGarageProfileData.images, img => {
        let imageIndex = findIndex(imageArray, localImg => {
          return (localImg.localUniqueId && img.localUniqueId && localImg.localUniqueId == img.localUniqueId) ||
            localImg.id == img.id;
        });
        if (imageIndex != -1) {
          imageArray[imageIndex] = img;
        } else if (img.id) {
          imageArray.push(img);
        }
      });
      if (nextProps.vendorProfileReducer && nextProps.vendorProfileReducer.deletedImageId) {
        remove(imageArray, function(f) {
          return f.id == nextProps.vendorProfileReducer.deletedImageId;
        });
      }
      this.setState({
        selectedImages: imageArray
      });
    }
  }
  componentWillUnmount() {
    this.props.actions.hideErrorMessage();
  }

  createGarageProfile(e) {
    e.preventDefault();
    let isDaySelected = false;
    map(this.state.daySelected, day => {
      if (day == true) {
        isDaySelected = true;
      }
    });
    let formData = {
      ...this.formData
    };
    if (this.state.selectedImages && this.state.selectedImages.length <= 5) {
      this.setState({ imageMaxLimitError: false });
      this.errors['imageMaxLimitError'] = false;
    } else {
      this.setState({ imageMaxLimitError: true });
      this.errors['imageMaxLimitError'] = true;
    }
    // this.errors['company_logo'] = !(this.formData.company_logo && this.formData.company_logo.length > 0);
    let workingHours = [...this.state.workingHours];
    let fromTime = this.state.fromTime;
    let toTime = this.state.toTime;
    if (this.state.daySelected.sunday) {
      workingHours.push({
        day: 1,
        range: [
          {
            from: fromTime,
            to: toTime
          }
        ]
      });
    }
    if (this.state.daySelected.monday) {
      workingHours.push({
        day: 2,
        range: [
          {
            from: fromTime,
            to: toTime
          }
        ]
      });
    }
    if (this.state.daySelected.tuesday) {
      workingHours.push({
        day: 3,
        range: [
          {
            from: fromTime,
            to: toTime
          }
        ]
      });
    }
    if (this.state.daySelected.wednesday) {
      workingHours.push({
        day: 4,
        range: [
          {
            from: fromTime,
            to: toTime
          }
        ]
      });
    }
    if (this.state.daySelected.thrusday) {
      workingHours.push({
        day: 5,
        range: [
          {
            from: fromTime,
            to: toTime
          }
        ]
      });
    }
    if (this.state.daySelected.friday) {
      workingHours.push({
        day: 6,
        range: [
          {
            from: fromTime,
            to: toTime
          }
        ]
      });
    }
    if (this.state.daySelected.saturday) {
      workingHours.push({
        day: 7,
        range: [
          {
            from: fromTime,
            to: toTime
          }
        ]
      });
    }
    this.setState({ submissionError: false });
    this.formData['cash'] = this.state.cash;
    this.formData['card'] = this.state.card;

    this.errors['working_hours_limit'] = workingHours.length == 0;
    if (
      this.state.selectedLocation &&
      this.state.selectedLocation.lat &&
      this.state.selectedLocation.lng &&
      this.state.selectedLocation.address
    ) {
      this.errors['address'] = false;
      this.formData['address'] = this.state.selectedLocation.address;
      this.formData['latitude'] = this.state.selectedLocation.lat;
      this.formData['longitude'] = this.state.selectedLocation.lng;
    } else {
      this.errors['address'] = true;
    }
    if(this.formData['about'] === ''){
      this.errors['about'] = true;
    } else {
      this.errors['about'] = false;
    }
    if(this.state.selectedImages.length > 0){
      this.errors['cover_image'] = false;
    } else {
      this.errors['cover_image'] = true;
    }
    delete this.errors['company_logo'];
    const validatedForm = validateFormSubmit(this.formData, this.errors);
    this.errors = validatedForm.errors;
    let validForm = true;
    for (const key in this.errors) {
      if (this.errors[key]) {
        validForm = false;
      }
    }
    if (!validatedForm.validForm || !validForm) {
      setTimeout(()=> {
        window.scroll(0, this.findPos(document.getElementsByClassName("error-text")[0]));
      }); 
      this.setState({ submissionError: true });
      return;
    } else {
      const authData = localStorage.businessAuthData ? JSON.parse(localStorage.businessAuthData) : '';
      this.setState({ submissionError: false, isButtonLoading: true });
      this.props.actions.CreateVendorProfile(
        this.formData,
        this.state.selectedFacilities,
        workingHours,
        authData &&
          authData.isBusinessRegistered &&
          authData.isGarageProfileCompleted &&
          authData.isGarageServiceSelected,
        this.props.vendorProfileReducer.newGarageProfileData.batch_id,
        this.props.router,
        this.state.newImagesArray
      );
    }
  }

  //Finds y value of given object
findPos(obj) {
  var curtop = 0;
  if (obj &&obj.offsetParent) {
      do {
          curtop += obj.offsetTop;
      } while (obj = obj.offsetParent);
  return (curtop-200);
  }
}

  uploadImageError(value) {
    this.props.actions.addGarageProfilePictureTest(
      value,
      this.props.vendorProfileReducer.newGarageProfileData.batch_id,
      '',
      false
    );
  }

  fileNameUpload(e) {
    let files = [], fileImgSizeError = false, errFileType = false, fileBlob = [];
    this.setState({ uploadImageErrText: false });
    each(e.target.files, val => {
      files.push({ name: val.name, path: URL.createObjectURL(val), size: val.size });
      val.localUniqueId = uniqid();
      fileBlob.push(val);
      if (val.size > 25000000) {
        fileImgSizeError = true;
      }
      if (val.type == 'image/png' || val.type == 'image/jpeg') {
      } else {
        errFileType = true;
      }
    });
    let upload = [...this.state.selectedImages];
    // if (this.state.selectedImages.length < 5 && this.state.selectedImages.length + files.length > 5) {
    //   files = slice(files, 0, 5 - this.state.selectedImages.length);
    //   fileBlob = slice(fileBlob, 0, 5 - this.state.selectedImages.length);
    //   this.setState({ imageMaxLimitError: true });
    // } else
    if (this.state.selectedImages.length + files.length > 5) {
      files = [];
      fileBlob = [];
      //limiterror
      this.setState({ imageMaxLimitError: true });
    } else {
      this.setState({ imageMaxLimitError: false });
    }
    upload = concat(upload, files);
    e.target.value = null;

    if (fileImgSizeError || errFileType == true) {
      this.setState({ uploadImageErrText: true });
    } else {
      // this.state.uploadImgSize += fileImgSize;
      // this.setState({
      //   uploadImgSize: fileImgSize + this.state.uploadImgSize,
      // });
      // this.props.actions.addGarageProfilePicture(fileBlob, this.props.vendorProfileReducer.newGarageProfileData.batch_id);
      let selectedImages = [...this.state.selectedImages];
      let that = this;
      map(fileBlob, value => {
        // this.props.actions.getSignedURL(value, 'vendor', this.props.vendorProfileReducer.newGarageProfileData.batch_id, (data) => {
        //   if (data) {
        //     that.props.actions.uploadImage(value, data.signed_request, data.url, data.imageId, true, (imageId) => {
        //       let newImagesArray = cloneDeep(this.state.newImagesArray);
        //       newImagesArray.push(imageId);
        //       this.setState({ newImagesArray: newImagesArray });
        //       that.props.actions.addGarageProfilePictureTest(value, this.props.vendorProfileReducer.newGarageProfileData.batch_id, imageId, true);

        //       if(that.props.vendorProfileReducer.newGarageProfileData.images && that.props.vendorProfileReducer.newGarageProfileData.images.length && that.props.vendorProfileReducer.newGarageProfileData.images[0] && that.props.vendorProfileReducer.newGarageProfileData.images[0].id == data.imageId && that.props.routeParams && that.props.routeParams.id){
        //         that.props.actions.changeBusinessCoverImage(data.imageId);
        //       }

        //     }, () => this.uploadImageError(value));
        //   }
        // }, () => this.uploadImageError(value), this.props.vendorProfileReducer.garageProfileDetails && this.props.vendorProfileReducer.garageProfileDetails.id);

        // selectedImages.push({
        //   isUploaded: false,
        //   isFailed: false,
        //   thumbnail: URL.createObjectURL(value),
        //   original: URL.createObjectURL(value),
        //   localUniqueId: value.localUniqueId,
        //   isCover: false
        // });

        let img = new Image();
        img.onload = function() {
          value.height = this.height;
          value.width = this.width;
          //   alert(this.width + " " + this.height);
          that.props.actions.getSignedURL(
            value,
            'vendor',
            that.props.vendorProfileReducer.newGarageProfileData.batch_id,
            data => {
              if (data) {
                that.props.actions.uploadImage(
                  value,
                  data.signed_request,
                  data.url,
                  data.imageId,
                  true,
                  imageId => {
                    let newImagesArray = cloneDeep(that.state.newImagesArray);
                    newImagesArray.push(imageId);
                    that.setState({ newImagesArray: newImagesArray });
                    that.props.actions.addGarageProfilePictureTest(
                      value,
                      that.props.vendorProfileReducer.newGarageProfileData.batch_id,
                      imageId,
                      true
                    );

                    if (
                      that.props.vendorProfileReducer.newGarageProfileData.images &&
                      that.props.vendorProfileReducer.newGarageProfileData.images.length &&
                      that.props.vendorProfileReducer.newGarageProfileData.images[0] &&
                      that.props.vendorProfileReducer.newGarageProfileData.images[0].id == data.imageId &&
                      that.props.routeParams &&
                      that.props.routeParams.id
                    ) {
                      that.props.actions.changeBusinessCoverImage(data.imageId);
                    }
                  },
                  () => that.uploadImageError(value)
                );
              }
            },
            () => that.uploadImageError(value),
            that.props.vendorProfileReducer.garageProfileDetails &&
              that.props.vendorProfileReducer.garageProfileDetails.id
          );
        };
        selectedImages.push({
          isUploaded: false,
          isFailed: false,
          thumbnail: URL.createObjectURL(value),
          original: URL.createObjectURL(value),
          localUniqueId: value.localUniqueId,
          isCover: false
        });
        img.onerror = function() {
          // alert( "not a valid file: " + value.type);
        };
        img.src = URL.createObjectURL(value);
      });
      this.setState({ selectedImages: selectedImages });
      if (upload.length > 3) {
        this.setState({ imagesLeft: true });
      } else {
        this.setState({ imagesLeft: false });
      }
      if(selectedImages.length > 0){
        this.errors['cover_image'] = false;
      } else {
        this.errors['cover_image'] = true;
      }
    }
  }
  closeModal() {
    this.setState({ showModal: false });
  }
  closeCompanyLogoModal() {
    this.setState({ showComapanyLogoModal: false });
  }
  companyLogoUpload(e) {
    let files = [], fileImgSize = 0, errFileType = false, fileBlob = [];
    this.setState({ uploadImageErrText: false });
    each(e.target.files, val => {
      files.push({
        name: val.name,
        path: URL.createObjectURL(val),
        size: val.size,
        original: URL.createObjectURL(val),
        thumbnail: URL.createObjectURL(val)
      });
      fileBlob.push(val);
      fileImgSize = val.size;
      if (val.type == 'image/png' || val.type == 'image/jpeg') {
      } else {
        errFileType = true;
      }
    });
    this.setState({ testCompanyImage: { original: files.length && files[0].path } });
    let width = 0;
    let height = 0;
    // let that = this;
    setTimeout(
      () => {
        let img = document.getElementById('vp-company-logo');
        // img.onload = function () {
        width = img.naturalWidth;
        height = img.naturalHeight;
        // }
        img.src = '';
        if (fileImgSize >= 1000000 || errFileType == true || fileBlob.length > 1 || width > 250 || height > 250) {
          this.errors['company_logo'] = fileBlob.length > 1 ? 'filelimit' : 'filesizeError';
          this.setState({ errorUpdated: !this.state.errorUpdated });
        } else {
          this.setState({
            companyLogo: files
          });
          if (fileBlob && fileBlob.length) {
            fileBlob[0].height = height;
            fileBlob[0].width = width;
          }
          this.formData['company_logo'] = fileBlob;
          this.errors['company_logo'] = false;
          this.setState({ errorUpdated: !this.state.errorUpdated });
        }
      },
      500
    );
    e.target.value = null;
  }

  onFieldBlur(value, name, validateError) {
    this.formData[name] = value;
    if (has(this.errors, name)) {
      this.errors[name] = validateError;
    }
  }

  cancelImageUpload(val, image) {
    // let deleteSize = 0;
    // if (this.state.uploadImgSize >= 20000000) {
    //   this.setState({ uploadImageErrText: true });
    // } else {
    //   this.setState({ uploadImageErrText: false });
    // }

    // const array = [...this.state.selectedImages];
    // deleteSize = this.state.uploadImgSize - this.state.selectedImages[val].size;
    // array.splice(val, 1);
    // let arr = this.state.deletedImages;
    // if (image.id) {
    //   arr.push(image.id)
    // }

    this.props.actions.removeGarageImage(image.id, this.state.selectedImages);

    // this.setState({ selectedImages: array, uploadImgSize: deleteSize, deletedImages: arr });
    // if (array.length > 3) {
    //   this.setState({ imagesLeft: true })
    // } else {
    //   this.setState({ imagesLeft: false })
    // }
  }

  cancelCompanyImageUpload() {
    this.setState({ companyLogo: [], showComapanyLogoModal: false });
    this.formData['company_logo'] = [];
    // this.errors['company_logo'] = true;
  }

  payment(e, val) {
    if (val == 'card') {
      this.setState({ card: e.target.checked });
    } else {
      this.setState({ cash: e.target.checked });
    }
  }

  changeWorkingHours(workingHours) {
    if (workingHours.length) {
      this.errors['working_hours_limit'] = false;
    }
    this.setState({ workingHours: workingHours });
  }

  lastWorkingHours(days, isWorkingHourValid,isUniqueWorkingHours, fromTime, toTime) {

    this.errors['working_hours'] = !isWorkingHourValid;
    this.errors['unique_working_hours'] = !isUniqueWorkingHours;
    this.setState({ fromTime: fromTime, toTime: toTime, daySelected: days });
  }

  setAsCover(image) {
    if (image.id) {
      this.props.actions.changeBusinessCoverImage(image.id);
    }
  }

  render() {
    const imgSrc = this.state.selectedImages && this.state.selectedImages.length > 0
      ? this.state.selectedImages[Object.keys(this.state.selectedImages).length - 1]
      : '';
    const style = {
      uploadBgk: {
        backgroundImage: `url('${imgSrc.original ? imgSrc.original : imgSrc.path}')`
      }
    };
    const imageUploadedView = map(this.state.selectedImages, (img, index) => {
      if (index < 3) {
        return (
          <div className="upload-box-wrapper box-shadow" key={index}>

            {img.isUploaded ? <span className="cancel-image" onClick={() => { this.cancelImageUpload(index, img); }}>
              <i className="mdi mdi-close" />
            </span> : ''}
            <img src={img.thumbnail ? img.thumbnail : img.path} onClick={() => {
              img.isUploaded && this.setState({ showModal: true, imageStartIndex: index });
            }} />
            {!img.isUploaded ?
              <div className="c-loader-img"><img className="img-loader-on-upload" src={`${imageBasePath}/loader_white.gif`} alt="Upload in progress" /></div>
              : ''}
          </div>
        );
      } else if (index == 3) {
        return (
          <div
            className={
              this.state.selectedImages && this.state.selectedImages.length <= 4
                ? 'upload-box-wrapper box-shadow'
                : 'upload-box-wrapper box-shadow more-images'
            }
            key={index}
          >
            {img.isUploaded && this.state.selectedImages && this.state.selectedImages.length <= 4
              ? <span
                  className="cancel-image"
                  onClick={() => {
                    this.cancelImageUpload(index, img);
                  }}
                >
                  <i className="mdi mdi-close" />
                </span>
              : ''}
            <img
              src={img.thumbnail ? img.thumbnail : img.path}
              onClick={() => {
                img.isUploaded && this.setState({ showModal: true, imageStartIndex: index });
              }}
            />
            {!img.isUploaded
              ? <div className="c-loader-img">
                  <img
                    className="img-loader-on-upload"
                    src={`${imageBasePath}/loader_white.gif`}
                    alt="Upload in progress"
                  />
                </div>
              : ''}
            {this.state.selectedImages && this.state.selectedImages.length > 4
              ? <label
                  className="more-popup"
                  onClick={() => {
                    img.isUploaded && this.setState({ showModal: true, imageStartIndex: index });
                  }}
                >
                  +1 More
                </label>
              : ''}
          </div>
        );
      }
    });

    const facilities = map(this.state.facilitiesMasterList, (facility, index) => {
      return (
        <div className="checkbox-style checkbox-wrapper c-checkbox" key={index}>
          <input
            type="checkbox"
            id={facility.text}
            checked={this.isFacilitySelected(facility.id)}
            onChange={e => {
              this.facilityChanged(e.target.checked, facility);
            }}
          />
          <label htmlFor={facility.text} className="custom-checkbox" />
          <span className="facilityImg"><img src={facility && facility.image ? facility.image : ''} alt="" /> </span>
          <label htmlFor={facility.text} className="chk-label">
            {facility.text}
          </label>
        </div>
      );
    });

    const authData = localStorage.businessAuthData ? JSON.parse(localStorage.businessAuthData) : '';
    return (
      <div>
        <Header
          searchMobile={this.state.searchMobile}
          commonReducer={this.props.commonReducer}
          actions={this.props.actions}
          notificationCount={2}
          profileName="Derrick Frank"
          notificationCallBack={this.toggleNotification}
          authReducer={this.props.authReducer}
          hCallback={() => {
            this.hclickCallBack();
          }}
          router={this.props.router}
          isNewUser={
            authData &&
              authData.isBusinessRegistered &&
              authData.isGarageProfileCompleted &&
              authData.isGarageServiceSelected
              ? false
              : true
          }
        />
        <MobileNotification isVisible={this.state.notificationVisible} backBtnCallBack={this.toggleNotification} />
        <div className="main-wrapper">
          {authData &&
            authData.isBusinessRegistered &&
            authData.isGarageProfileCompleted &&
            authData.isGarageServiceSelected &&
            <Sidebar
              showSidebar={this.state.showSidebar}
              router={this.props.router}
              actions={this.props.actions}
              commonReducer={this.props.commonReducer}
              authReducer={this.props.authReducer}
            />}
          <div
            className={
              authData &&
                authData.isBusinessRegistered &&
                authData.isGarageProfileCompleted &&
                authData.isGarageServiceSelected
                ? 'container-fluid main-container'
                : 'container-fluid main-container con-align'
            }
          >
            <div className="col-md-12 mpad0 profile">
              <div className="overview-heading">
                <h5>Manage Profile</h5>
              </div>
              {authData &&
                authData.isBusinessRegistered &&
                (!authData.isGarageProfileCompleted && !authData.isGarageServiceSelected) &&
                <ActivationStepDetails
                  isGarageProfileCompleted={authData.isGarageProfileCompleted}
                  isGarageServiceSelected={authData.isGarageServiceSelected}
                />}
              <div className="row">
                <div className="col-md-8 pad0">
                  <div className="content-view">
                    <div className="sec-title">
                      <h5>profile details</h5>
                    </div>
                    <div className="sec-body">
                      <TextInput
                        label="Company profile name.*"
                        type="text"
                        name="companyprofilename"
                        value={this.formData['companyprofilename']}
                        onBlur={this.onFieldBlur.bind(this)}
                        validationError={validationMessage.company.emptyError}
                        emptyError={validationMessage.company.emptyError}
                        showValidationError={this.errors['companyprofilename']}
                      />
                      <TextInput
                        label="Promotion Text"
                        type="text"
                        name="promotiontext"
                        value={this.formData['promotiontext']}
                        onBlur={this.onFieldBlur.bind(this)}
                      />
                      <div className="content-holder">
                        <h5>About the company.*</h5>
                        <FormGroup>
                          <FormControl
                            maxLength="1000"
                            value={this.formData['about']}
                            onChange={e => {
                              let about = e.target.value;
                              if (about && about.length) {
                                this.errors['about'] = false;
                              } else {
                                this.errors['about'] = true;
                              }
                              this.formData['about'] = about;
                              this.setState({ textUpdated: !this.state.textUpdated });
                            }}
                            style={{ height: '90px' }}
                            className="textAlign"
                            componentClass="textarea"
                          />
                        </FormGroup>
                        {this.errors['about'] &&
                            <span className="error-text maps-address-picker">About the company field cannot be empty</span>}
                      </div>
                      <div className="content-holder facilities">
                        <h5>Facilities</h5>
                        {facilities}
                        {/* <span>add another facility</span> */}
                      </div>

                      <div className="content-holder upload-image c-upload-holder">
                        <h5>Company logo</h5>
                        {this.state.companyLogo &&
                          size(this.state.companyLogo) == 0 &&
                          <Upload id="companyLogoUpload" fileUpload={e => this.companyLogoUpload(e)} />}
                        <img
                          id={'vp-company-logo'}
                          style={{ position: 'absolute', visibility: 'hidden', height: '0px', width: '0px' }}
                          src={this.state.testCompanyImage.original ? this.state.testCompanyImage.original : ''}
                        />
                        <div className="view-wrapper">
                          {this.state.companyLogo[0] &&
                            <div className="upload-box-wrapper box-shadow">
                              <span
                                className="cancel-image"
                                onClick={() => {
                                  this.cancelCompanyImageUpload();
                                }}
                              >
                                <i className="mdi mdi-close" />
                              </span>
                              <img
                                onClick={() => {
                                  this.setState({ showComapanyLogoModal: true });
                                }}
                                src={
                                  this.state.companyLogo[0].original
                                    ? this.state.companyLogo[0].original
                                    : this.state.companyLogo[0].path
                                }
                              />
                            </div>}
                        </div>
                        {this.errors['company_logo'] == true
                          ? <span className="image-upload-error">
                              <p>Please Upload the company Logo.</p>
                            </span>
                          : ''}
                        {this.errors['company_logo'] == 'filesizeError' &&
                          <span className="image-upload-error">
                            <p>
                              Sorry, the file size should not be above 1MB and should be in JPG or PNG format. Dimension should be less than 250px X 250px
                            </p>
                          </span>}
                        {this.errors['company_logo'] == 'filelimit' &&
                          <span className="image-upload-error">
                            <p>Maximum image limit for logo is one.</p>
                          </span>}

                        <div className="upload-notes">
                          <label>
                            The file has to be below 1 MB. Please use JPG or PNG. Maximum Dimension 250px X 250 px
                          </label>
                        </div>
                      </div>

                      <div className="content-holder upload-image c-upload-holder company-img-wrapper">
                        <h5>Company images.*</h5>
                        {this.state.selectedImages && this.state.selectedImages.length < 5
                          ? <Upload id="carProfileUpload" fileUpload={e => this.fileNameUpload(e)} />
                          : ''}
                        <div className="view-wrapper">
                          {imageUploadedView}
                        </div>
                        {/* {this.state.selectedImages && this.state.selectedImages.length > 3 && <div className="more-wrapper" onClick={() => { this.setState({ showModal: true, imageStartIndex: 3 }); }}>
                          <label htmlFor="more-images" className="upload-box">
                            <span className="images-left">+{this.state.selectedImages.length - 4} {window.innerWidth > 600 ? " More" : null}
                            </span>
                            <img style={style.uploadBgk} className="uploadbg" />
                          </label>
                        </div>} */}
                      </div>
                      <span
                        className={
                          this.state.uploadImageErrText ? 'image-upload-error' : 'image-upload-error padLeft15 hide'
                        }
                      >
                        <p>Sorry, the file size should not be above 25MB and should be in JPG or PNG format.</p>
                        <i className="mdi mdi-close" onClick={() => this.setState({ uploadImageErrText: false })} />
                      </span>
                      {this.errors['cover_image']
                          && <span  className="error-text image-upload-error">
                              <p>Please Upload the company Image.</p>
                            </span>
                      }
                      <span
                        className={
                          this.state.imageMaxLimitError ? 'image-upload-error' : 'image-upload-error padLeft15 hide'
                        }
                      >
                        <p>Maximum allowed limit is 5.</p>
                        <i className="mdi mdi-close" onClick={() => this.setState({ imageMaxLimitError: false })} />
                      </span>
                    </div>

                  </div>
                </div>
                <div className="col-md-4 right padRight0">
                  <div className="content-view">
                    <div className="sec-title">
                      <h5>contact details</h5>
                    </div>
                    <div className="sec-body">
                      <div className="content-holder">
                        {/* <TextInput
                          label="Door Number"
                          type="text"
                          name="door"
                          value={this.formData['door']}
                          onBlur={this.onFieldBlur.bind(this)}
                          validationError={'Please enter the Door Number'}
                          showValidationError={this.errors['door']} /> */}
                        <div
                          onClick={e => {
                            e.preventDefault();
                            this.setState({ showLocationModal: true });
                          }}
                        >
                          <TextInput
                            customClass={this.state.selectedLocation.address ? 'addressInput active' : 'addressInput'}
                            readOnly={true}
                            label="Address"
                            type="text"
                            name="address"
                            value={this.state.selectedLocation.address}
                            onBlur={this.onFieldBlur.bind(this)}
                          />
                          {this.errors['address'] &&
                            <span  className="error-text maps-address-picker">Address field cannot be empty</span>}
                        </div>

                        {/* <div className="gmaps">
                          <Gmaps
                            center={{
                              lat: 12.9952672,
                              lng: 77.5905857
                            }}
                            zoom={9}
                            containerElement={<div style={{ height: "auto", width: 100 + '%' }} />}
                            mapElement={<div style={{ height: 192 + 'px', width: 100 + '%' }} />}
                          />


                        </div> */}
                        {/* <span className="locateOnMap" onClick={() => { this.setState({ showLocationModal: true }); }}>Locate on map</span> */}
                      </div>
                      <div className="content-holder phone-card">
                        <TextInput
                          type="phone"
                          label="Mobile Number"
                          name="phone"
                          value={Number(this.formData['phone'])}
                          onBlur={this.onFieldBlur.bind(this)}
                          validationError={validationMessage.phone.emptyError}
                          emptyError={validationMessage.phone.emptyError}
                          showValidationError={this.errors['phone']}
                        />

                        {this.errors['phone']
                          ? <span  className="error-text">Please enter the Phone Number</span>
                          : <div />}
                      </div>
                      <TextInput
                        label="Website"
                        type="text"
                        name="website"
                        value={this.formData['website']}
                        onBlur={this.onFieldBlur.bind(this)}
                      />
                      <TextInput
                        label="Email"
                        type="email"
                        name="email"
                        value={this.formData['email']}
                        onBlur={this.onFieldBlur.bind(this)}
                        validationError={validationMessage.email.emptyError}
                        emptyError={validationMessage.email.emptyError}
                        showValidationError={this.errors['email']}
                      />
                      <div className="content-holder payment-method">
                        <h5>accepted payment method</h5>
                        <div className="checkbox-style checkbox-wrapper">
                          <input
                            type="checkbox"
                            id="check-cash"
                            checked={this.state.cash}
                            onChange={e => {
                              this.payment(e, 'cash');
                            }}
                          />
                          <label htmlFor="check-cash" className="custom-checkbox" />
                          <label htmlFor="check-cash">
                            Cash
                          </label>
                        </div>
                        <div className="checkbox-style checkbox-wrapper">
                          <input
                            type="checkbox"
                            id="check-card"
                            checked={this.state.card}
                            onChange={e => {
                              this.payment(e, 'card');
                            }}
                          />
                          <label htmlFor="check-card" className="custom-checkbox" />
                          <label htmlFor="check-card">
                            Credit Card
                          </label>
                        </div>
                      </div>
                      <WorkingTime
                        isSelected={this.errors['working_hours_limit']}
                        isError={this.errors['working_hours']}
                        lastWorkingHours={this.lastWorkingHours.bind(this)}
                        workingHours={this.state.workingHours}
                        callback={this.changeWorkingHours}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <SelectAddressModal actions={this.props.actions} showModal={this.state.showLocationModal} selectedLocationCallBack={(selectedLocation) => { this.errors['address'] = false; this.setState({ 'selectedLocation': selectedLocation, 'showLocationModal': false }); }} selectedLocation={this.state.selectedLocation} hideModalCallback={() => { this.setState({ 'showLocationModal': false }) }} />
              <Button customClass="mp-save" btnCallBack={this.createGarageProfile.bind(this)} btnType="red" btnSize="sm" fontSize={15} label={(authData && authData.isBusinessRegistered && authData.isGarageProfileCompleted && authData.isGarageServiceSelected) ? "Save" : "Next"} isButtonLoading={this.state.isButtonLoading} />
              {/*Location modal*/}
            </div>
          </div>
        </div>
        {this.state.selectedImages && this.state.selectedImages.length
          ? <LightBox
              showUploadIcon={this.state.selectedImages.length < 5}
              showSetAsCover={true}
              actions={this.props.actions}
              images={this.state.selectedImages}
              imageStartIndex={this.state.imageStartIndex}
              showModal={this.state.showModal}
              isEditable={true}
              closeModal={this.closeModal.bind(this)}
              fileUpload={this.fileNameUpload.bind(this)}
              setAsCover={this.setAsCover}
              deleteImage={this.cancelImageUpload.bind(this)}
            />
          : ''}
        {this.formData.company_logo && this.formData.company_logo.length > 0
          ? <LightBox
              showUploadIcon={this.formData.company_logo.length < 1}
              actions={this.props.actions}
              images={this.state.companyLogo}
              imageStartIndex={0}
              showModal={this.state.showComapanyLogoModal}
              isEditable={true}
              closeModal={this.closeCompanyLogoModal.bind(this)}
              fileUpload={this.companyLogoUpload.bind(this)}
              deleteImage={this.cancelCompanyImageUpload.bind(this)}
            />
          : ''}
      </div>
    );
  }
}

export default ProfileCreation;



// WEBPACK FOOTER //
// ./src/components/ProfileCreation/ProfileCreation.jsx